document.addEventListener('DOMContentLoaded', function () {

  const header = document.getElementById('header');

  if (header) {
    const updateHeader = function () {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };

    updateHeader();

    window.addEventListener('scroll', updateHeader, {
      passive: true
    });
  }

  const revealEls = document.querySelectorAll('.reveal, .feature');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12
    });

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('in');
    });
  }

  document.querySelectorAll('.faq-q').forEach(function (question) {
    question.addEventListener('click', function () {
      const item = question.closest('.faq-item');

      if (!item) return;

      const isOpen = item.classList.contains('open');

      document.querySelectorAll('.faq-item.open').forEach(function (openItem) {
        openItem.classList.remove('open');
      });

      if (!isOpen) {
        item.classList.add('open');
      }
    });
  });


  // BNKR26 → BNKR with 26 superscript
  document.querySelectorAll('.new-landing-main p, .new-landing-main span, .new-landing-main .price-foot, #get-info p').forEach(function (element) {
    element.innerHTML = element.innerHTML.replaceAll(
      'BNKR26',
      'BNKR<sup>26</sup>'
    );
  });

});

 document.addEventListener('DOMContentLoaded', function () {
    var phoneRegex = /\(\d{3}\)\s?\d{3}-\d{4}/g;

    document.querySelectorAll('.f-list li, .proc-step p').forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(phoneRegex, function (match) {
        var digits = match.replace(/\D/g, '');
        return '<a href="tel:' + digits + '">' + match + '</a>';
      });
    });
  });
